import './modules/register-service-worker';
import 'alpinejs';
import './modules/api';
import 'add-to-calendar-button';

// Admin styles / scripts on when needed
if (document.body.classList.contains('is-admin')) {
  import('./modules/admin');
}

// Swiper (slider)
if (document.querySelector('.swiper-container')) {
  import('./modules/swiper');
}

// Controllers (Stimulusjs)
if (document.querySelector('[data-controller]:not(.stock-chart)')) {
  import('./modules/controllers');
}

// Stock chart controller
if (document.querySelector('.stock-chart')) {
  import('./modules/stock-chart.js');
}

// Lazy load images
if (document.querySelector('.lazy')) {
  import('./modules/lazy');
}

// Responsive tables
if (document.querySelector('#content table')) {
  import('./modules/responsive-table');
}

// Hubspot material download
if (document.querySelector('.js-hubspot-material')) {
  import('./modules/hubspot-download');
}

// Cookie consent
if (document.querySelector('html[lang="zh"]')) {
  import('./modules/cookie-popup-zh.js');
} else {
  import('./modules/cookie-popup.js');
}

// Addsearch
if (document.querySelector('.js-addsearch')) {
  import('./modules/addsearch');
}

// Graphs
if (document.querySelector('.highchart-graphs')) {
  import('./modules/graphs');
}

// Campaign page
if (document.querySelector('.campaign-page')) {
  import('./modules/campaign');
}
